import { ReactNode, ReactElement } from 'react';
import { OidcSecure } from '@axa-fr/react-oidc';
import { InitErrorBoundary } from './InitErrorBoundary';

/**
 * 画面リロード時の初期処理を行うコンポーネント
 */
function BaseInit({ children }: { children: ReactNode }): ReactElement | null {
  return <OidcSecure>{children}</OidcSecure>;
}

export function Init({ children }: { children: ReactNode }) {
  return (
    <InitErrorBoundary>
      <BaseInit>{children}</BaseInit>
    </InitErrorBoundary>
  );
}
